import * as SecureStore from "@towersystems/roam-common-native";
import { TransactionRequestResponse } from "./types";
const STORAGE_KEY = "smartpay_session";

export const generateDeviceId = (
  terminalId: string,
  paymentMethodId: string
) => {
  return `idx_${terminalId}_${paymentMethodId}`;
};

export type CachedSmartPaySession = {
  saleId: string;
  transactionRequestResponse: TransactionRequestResponse;
};

export const saveSmartPayPaymentSession = async ({
  saleId,
  transactionRequestResponse,
}: {
  saleId: string;
  transactionRequestResponse: TransactionRequestResponse;
}): Promise<void> => {
  const session: CachedSmartPaySession = {
    saleId,
    transactionRequestResponse,
  };
  await SecureStore.storeItemAsync(STORAGE_KEY, JSON.stringify(session));
  return;
};

export const retrieveSalePaymentSession = async ({
  saleId,
}: {
  saleId: string;
}): Promise<TransactionRequestResponse | undefined> => {
  const data = await SecureStore.getItemAsync(STORAGE_KEY);
  if (data) {
    const session: CachedSmartPaySession = JSON.parse(data);
    if (session.saleId === saleId) {
      return session.transactionRequestResponse;
    }
  }
  return undefined;
};

export const clearSmartPayPaymentSession = async () => {
  await SecureStore.deleteItemAsync(STORAGE_KEY);
  return;
};
